import tw from "twin.macro";

import { SquaredLogo } from "@/assets/logos";
import { LoadingSpinner } from "@/components/LoadingIndicator";
import { Transition } from "@/components/Transition";

type FullPageLoadingScreenProps = { show: boolean };

export const FullPageLoadingScreen = ({ show }: FullPageLoadingScreenProps) => {
  return (
    <Transition
      show={show}
      as={"div"}
      enterFrom={tw`opacity-0`}
      enterTo={tw`opacity-100`}
      leaveFrom={tw`opacity-100`}
      leaveTo={tw`opacity-0`}
      tw="transition-opacity duration-700 fixed inset-0 z-50 p-8 h-screen w-full bg-primary-800 flex flex-col gap-16 justify-center items-center pointer-events-none select-none"
    >
      <div tw="h-72 w-screen absolute top-0 right-0 -translate-y-1/2 translate-x-1/3 rounded-bl-[70%] bg-primary-600/50" />

      <div tw="h-72 w-screen absolute bottom-0 left-0 translate-y-1/2 -translate-x-1/3 rounded-tr-[70%] bg-primary-900/75" />

      <SquaredLogo onPrimary />
      <LoadingSpinner tw="h-7 text-white" />
    </Transition>
  );
};
